import {
  Button,
  Form,
  Modal,
  Row,
  Spin,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import React, { useEffect } from "react";
import FloatingInput from "../../common/float-input/FloatInput";
import FloatingTextArea from "../../common/floating-textarea/FloatingTextArea";
import "./RequestExternalSearch.css";
import { useDispatch, useSelector } from "react-redux";
import { requestExternalSearch } from "../../../store/thunks/buyer-thunks/BuyerThunks";
import { clearRfpPdf } from "../../../store/slices/common-slice/rfp/rfpSlice";

const RequestExternalSearch = ({
  requestExtersearch,
  setRequestExternalSearch,
  campaignInfo,
  loggedinUser,
}) => {
  const dispatch = useDispatch();
  const { rfpPdf, isLoading } = useSelector((state) => state.rfp);
  const [form] = Form.useForm();
  const { Text } = Typography;

  const textAreaFloatingInputStyles = {
    "--input-height": "120px",
    "--label-font-size": "10px",
    "--input-font-weight": 500,
    "--input-padding-top": "1rem",
    "--label-focused-top": "22px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "10px",
  };

  const onFinish = (values) => {
    const payload = {
      user_query: values.user_query,
      budget_rfp: values.budget_rfp,
      campaign_id: campaignInfo?.id,
      loggedinUser,
    };

    dispatch(requestExternalSearch(payload));
  };
  const base64ToUint8Array = (base64) => {
    const raw = atob(base64); // Decode base64 string
    const uint8Array = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) {
      uint8Array[i] = raw.charCodeAt(i);
    }
    return uint8Array;
  };
  useEffect(() => {
    if (isLoading === false) {
      setRequestExternalSearch(false);
      form.resetFields();
    }
  }, [isLoading]);

  useEffect(() => {
    let pdfData = rfpPdf;
    let pdfBlob;

    if (pdfData instanceof Blob) {
      pdfBlob = pdfData;
    } else if (
      typeof pdfData === "string" &&
      pdfData.startsWith("data:application/pdf;base64,")
    ) {
      const base64 = pdfData.split(",")[1];
      const byteArray = base64ToUint8Array(base64);
      pdfBlob = new Blob([byteArray], { type: "application/pdf" });
    } else if (typeof pdfData === "string" && pdfData.startsWith("%PDF")) {
      // Treat as binary string directly (like old app)
      pdfBlob = new Blob([pdfData], { type: "application/pdf" });
    } else {
      console.error("Unsupported PDF format");
      return;
    }

    const url = window.URL.createObjectURL(pdfBlob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "RFP.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    dispatch(clearRfpPdf());
  }, [rfpPdf, dispatch]);
  return (
    <Modal
      open={requestExtersearch}
      onCancel={() => setRequestExternalSearch(false)}
      footer={false}
      title={
        <Text className="request-search-header">Request External Search</Text>
      }
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row>
          <Text className="request-sub-text">
            External Search is subject to the same terms and conditions as
            outlined in the AMP user Agreement.
          </Text>
        </Row>

        <Row>
          <Form.Item>
            <Text className="request-campaignname">Campaign Name : </Text>
            <Text className="request-campaignname-value">
              {campaignInfo?.name}
            </Text>
          </Form.Item>
        </Row>

        <Form.Item
          name="budget_rfp"
          rules={[{ required: true, message: "Please enter your budget." }]}
        >
          <FloatingInput label="Budget*" />
        </Form.Item>

        <Form.Item
          name="user_query"
          rules={[
            { required: true, message: "Please add additional information." },
          ]}
        >
          <FloatingTextArea
            label="Additional Information *"
            customStyles={textAreaFloatingInputStyles}
            className="billboard-input-feild billboard-text-area"
          />
        </Form.Item>

        <Row justify="end">
          <Button htmlType="submit" className="request-external-search-sve-btn">
            <Text className="submit-txt">Submit</Text>
          </Button>
        </Row>
      </Form>
      {isLoading && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </Modal>
  );
};

export default RequestExternalSearch;
